<div
  [formGroup]="confirmationForm"
  [ngClass]="[brand === 'VIVUS' ? 'vivus-style' : '', isMobile ? 'mobile' : '']"
  class="main-container outer-wrap"
>
  <div class="field-wrap">
    <button
      pButton
      pRipple
      (click)="returnToUpdateForm()"
      icon="pi pi-arrow-left"
      label="Вернуться к редактированию"
      class="p-button-text"
    ></button>
  </div>
  <div class="main-container inner-wrap">
    <div class="field-wrap text-center">
      <h4>Введите код подтверждения, полученный по SMS</h4>
    </div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-auto">
          <app-sms-code-field
            [formGroup]="confirmationForm"
            fieldName="confirmationCode"
            [size]="MASK.CONFIRMATION_CODE_SIZE"
            [loading]="loading"
            class="field-wrap"
            (completed)="sendSmsCode()"
            (focusout)="checkConfirmForm()"

          >
          </app-sms-code-field>
        </div>
      </div>
    </div>

    <div class="field-wrap">
      <span
        >Ввод кода подтверждения является аналогом собственноручной подписи, в
        соответствии c
        <a [href]="agreementLink" target="_blank"
          >Соглашением об использовании АСП</a
        ></span
      >
    </div>
    <div class="field-wrap resend-code-button">
      <span *ngIf="this.timesLeft > 0"
        >Запросить код повторно можно через:
        {{ convertSecondsToMinutes(this.timesLeft) }}</span
      >
      <span *ngIf="this.timesLeft <= 0" (click)="getConfirmationCode()"
        ><a>Запросить код повторно</a></span
      >
    </div>
    <div class="field-wrap d-flex flex-row justify-content-center continue-button">
      <p-button
        icon="pi pi-check"
        label="Продолжить"
        class="p-button-outlined"
        (click)="sendSmsCode()"
      ></p-button>
    </div>
  </div>
</div>
<app-gtm-container [stepNumber]="gtmStepNumber"></app-gtm-container>
